<nav aria-label="pagination" *ngIf="total>0" class="pagination-nav">
  <ul class="no-bullet">
    <li class="nav-dir">
      <button type="button" aria-label="Go To Previous Page" [attr.aria-disabled]="current === 1" [disabled]="current === 1"
        (click)="onPrevious()">
        <
      </button>
    </li>

    <li *ngFor="let page of pages;">
      <button type="button"
        class="page-num"
        [attr.aria-current]="page === current ? 'page' : null"
        [attr.aria-label]="page === current ? 'Current Page, Page ' + page : 'Go to Page ' + page"
        [class.current]="page === current"
        [class.more]="page === -1 || page === -2"
        [disabled]="page === -1 || page === -2"
        (click)="onGoTo(page)">
        {{ (page !== -1 && page !== -2) ? page : '...'}}
      </button>
    </li>

    <li class="nav-dir">
      <button type="button" aria-label="Go To Next Page" [attr.aria-disabled]="current === total" [disabled]="current === total" (click)="onNext()">
        >
      </button>
    </li>
  </ul>
</nav>
